<app-onboarding
  *ngIf="
    !isOnboardingDone &&
    deploymentFound &&
    isDesktop &&
    checkAllowedAccessToSite() &&
    showOnboarding &&
    false
  "
></app-onboarding>

<mat-sidenav-container
  [dir]="isRTL ? 'rtl' : 'ltr'"
  class="main"
  [ngClass]="{ 'main--inner': !isDesktop && isInnerPage }"
>
  <mat-sidenav opened mode="side" disableClose class="sidebar" *ngIf="isDesktop">
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <app-toolbar></app-toolbar>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
      <div class="footer-container">
        <app-footer></app-footer>
      </div>
    </div>
    <div
      class="mobile-page-nav"
      *ngIf="!isDesktop && !isInnerPage && !getLocation().startsWith('/post/create')"
    >
      <app-submit-post-button
        class="mobile-page-nav__add-post-btn"
        [isRound]="true"
        [hasIconOnly]="true"
        [hasText]="false"
        *ngIf="checkAllowedAccessToSite()"
      >
      </app-submit-post-button>
      <app-menu-list-links></app-menu-list-links>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-cookies-notification *ngIf="deploymentFound"></app-cookies-notification>

<app-spinner fullscreen="true" *ngIf="isShowLoader"></app-spinner>
